import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IVideoTutorial } from "../../../Pages/VideoPage/IVideoTutorial";

export const ListVideoTutorialsSlice = createSlice({
    name: "ListVideoTutorialsSlice",
    initialState: {} as IReduxState<IVideoTutorial[]>,
    reducers: {
        listVideoTutorials: (state, action) => {
            state.isLoading = true;
        },
        successlistVideoTutorials: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failurelistVideoTutorials: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearListVideoTutorials: (state) => {
            state.data = {};
        },
    },
});

export const {
    failurelistVideoTutorials,
    listVideoTutorials,
    successlistVideoTutorials,
    clearListVideoTutorials,
} = ListVideoTutorialsSlice.actions;

export default ListVideoTutorialsSlice.reducer;
